<div class="check-to-print download-hide" >
    <input type="checkbox"
           class="print-checkbox"
           id="print-{{key}}"
           (click)="notify.emit()">
</div>
